/* Naughty Hut footer (nh-i-footer): About "Read more", back to top, fade-up. */
(() => {
  'use strict';
  const root = document.getElementById('NhFooter');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // About: show the toggle only when the clamped text actually overflows
  const about = root.querySelector('[data-nhf-about]');
  const text = about?.querySelector('.nhf-about__text');
  const toggle = about?.querySelector('.nhf-about__toggle');
  if (about && text && toggle) {
    const check = () => {
      if (about.classList.contains('is-open')) return;
      toggle.hidden = text.scrollHeight <= text.clientHeight + 2;
    };
    check();
    window.addEventListener('resize', check, { passive: true });
    toggle.addEventListener('click', () => {
      const open = about.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
    });
  }

  // Back to top
  root.querySelector('[data-nhf-top]')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    const target = document.querySelector('#MainContent, main, [role="main"]');
    if (target) { if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  });

  // Fade-up columns (only when they start below the fold)
  if (reduce.matches || !('IntersectionObserver' in window)) return;
  const items = [...root.querySelectorAll('.nhf-rise')];
  if (!items.length || root.getBoundingClientRect().top < window.innerHeight) return;
  root.classList.add('nhf-anim');
  items.forEach((el, i) => el.style.setProperty('--i', String(i)));
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }, { rootMargin: '0px 0px -8% 0px' });
  items.forEach((el) => io.observe(el));
})();
/* Ticker: pause on touch and while off-screen (hover/focus pause is CSS). */
(() => {
  const tick = document.querySelector('#NhFooter [data-nhf-tick]');
  if (!tick) return;
  /* QA fix A (A11Y-04): a real pause/play button; a paused strip stays paused (touch no longer resumes it). */
  const btn = tick.querySelector('[data-nhf-tick-toggle]');
  const setHeld = (on, save) => {
    tick.classList.toggle('is-held', on);
    btn?.setAttribute('aria-pressed', String(on));
    if (save) { try { localStorage.setItem('nhMqPaused', on ? '1' : '0'); } catch (e) { /* private mode */ } }
  };
  try { if (localStorage.getItem('nhMqPaused') === '1') setHeld(true, false); } catch (e) { /* private mode */ }
  btn?.addEventListener('click', () => setHeld(!tick.classList.contains('is-held'), true));
  tick.addEventListener('touchstart', () => tick.classList.add('is-paused'), { passive: true });
  tick.addEventListener('touchend', () => setTimeout(() => tick.classList.remove('is-paused'), 1500), { passive: true });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { tick.classList.toggle('is-off', !e.isIntersecting); }).observe(tick);
  }
})();
/* Newsletter sign-up -> Klaviyo list RqQVDY ("Email List", the Welcome Series trigger).
   Enhances every theme newsletter form (Shopify customer form tagged "newsletter":
   footer, home sign-up, theme popup). Without JS, or if Klaviyo can't be reached,
   the Shopify customer form posts exactly as before (progressive enhancement). */
(() => {
  'use strict';
  const KL = { company: 'RKmX3y', list: 'RqQVDY', revision: '2025-07-15' };
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/;
  const TXT = {
    ok: "You're in! Check your inbox for your 10% second-order code.",
    bad: 'Enter an email like name@example.co.nz.'
  };
  const isNewsletter = (f) => {
    if (!(f instanceof HTMLFormElement)) return false;
    const tags = f.querySelector('input[name="contact[tags]"]');
    return !!(tags && /newsletter/.test(tags.value) && f.querySelector('input[name="contact[email]"]'));
  };
  const sourceOf = (f) => {
    if (f.closest('#NhFooter')) return 'NH footer';
    const ctx = f.querySelector('input[name="contact[context]"]');
    if (ctx && ctx.value === 'nhi-signup') return 'NH home';
    return 'NH theme popup';
  };
  if (!document.getElementById('NhNlStyle')) {
    const st = document.createElement('style');
    st.id = 'NhNlStyle';
    st.textContent = '.nh-nl-msg{display:flex;align-items:flex-start;gap:8px;line-height:1.4}.nh-nl-msg[hidden]{display:none}' +
      '.nh-nl-msg svg{flex:none;inline-size:18px;block-size:18px;margin-block-start:1px}' +
      '.nhf-news__msg.nh-nl-msg--err{background:#fff;color:#8a0a27;box-shadow:inset 0 0 0 2px #ffb3c4}' +
      '.nhi-join__msg.nh-nl-msg--err{color:#8a0a27}' +
      '.nhf-news__input[aria-invalid=true]{box-shadow:0 0 0 2px #FF8FB0}.nhi-join__input[aria-invalid=true]{box-shadow:0 0 0 2px #E0103A}' +
      'form[data-nh-nl-busy] button[type=submit]{opacity:.75;cursor:progress}' +
      'form[data-nh-nl-done] .nhf-news__field,form[data-nh-nl-done] .nhi-join__label,form[data-nh-nl-done] .nhi-join__input,form[data-nh-nl-done] .nhi-btn,form[data-nh-nl-done] .input-group{display:none}';
    document.head.appendChild(st);
  }
  const ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z"/></svg>';
  const ICON_ERR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>';
  const msgFor = (f) => {
    let m = f.querySelector('[data-nh-nl-msg]');
    if (m) return m;
    f.querySelectorAll('.nhf-news__msg, .nhi-join__msg, .note').forEach((n) => n.remove());
    m = document.createElement('p');
    m.setAttribute('data-nh-nl-msg', '');
    m.setAttribute('tabindex', '-1');
    m.className = 'nh-nl-msg ' + (f.closest('#NhFooter') ? 'nhf-news__msg' : f.classList.contains('nhi-join__form') ? 'nhi-join__msg' : 'note');
    const anchor = f.querySelector('.nhf-news__field, .nhi-join__label, .input-group');
    f.insertBefore(m, anchor || f.firstChild);
    return m;
  };
  const show = (f, kind, text) => {
    const m = msgFor(f);
    m.hidden = false;
    m.setAttribute('role', kind === 'ok' ? 'status' : 'alert');
    m.classList.toggle('nh-nl-msg--err', kind !== 'ok');
    if (m.classList.contains('note')) { m.classList.toggle('note--success', kind === 'ok'); m.classList.toggle('note--error', kind !== 'ok'); }
    m.innerHTML = (kind === 'ok' ? ICON_OK : ICON_ERR) + '<span></span>';
    m.lastChild.textContent = text;
    return m;
  };
  const nativeSubmit = (f) => {
    f.dataset.nhNlNative = '1';
    if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit();
  };
  /* Fix batch 2026-09-29 (FE-F25 / D-43): the browser's own grey bubble ("Please include an '@'") fired before
     this handler, so shoppers saw an unbranded tooltip instead of the inline message. With JS, newsletter forms
     skip native validation and use the branded inline error; without JS the native check still applies. */
  const quiet = (f) => { if (isNewsletter(f)) f.noValidate = true; };
  document.querySelectorAll('form').forEach(quiet);
  window.addEventListener('focusin', (e) => { if (e.target && e.target.form) quiet(e.target.form); }, true);
  window.addEventListener('input', (e) => {
    const t = e.target;
    if (t && t.getAttribute && t.getAttribute('aria-invalid') === 'true' && t.form && isNewsletter(t.form) && EMAIL_RE.test((t.value || '').trim())) {
      t.removeAttribute('aria-invalid');
      const m = t.form.querySelector('[data-nh-nl-msg]');
      if (m && m.classList.contains('nh-nl-msg--err')) m.hidden = true;
    }
  }, true);
  window.addEventListener('submit', async (e) => {
    const f = e.target;
    if (!isNewsletter(f) || f.dataset.nhNlNative) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (f.dataset.nhNlBusy !== undefined) return;
    const input = f.querySelector('input[name="contact[email]"]');
    const btn = f.querySelector('button[type="submit"], input[type="submit"]');
    const email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      const m = show(f, 'err', TXT.bad);
      m.id = m.id || 'NhNlMsg-' + Math.random().toString(36).slice(2, 8);
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', m.id);
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    f.dataset.nhNlBusy = '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    const live = msgFor(f); live.hidden = true;
    const body = { data: { type: 'subscription', attributes: {
      custom_source: sourceOf(f),
      profile: { data: { type: 'profile', attributes: { email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: KL.list } } } } };
    let res = null;
    try {
      res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL.company, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KL.revision },
        body: JSON.stringify(body)
      });
    } catch (err) { res = null; }
    delete f.dataset.nhNlBusy;
    if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    if (res && res.ok) {
      f.dataset.nhNlDone = '';
      input.value = '';
      const m = show(f, 'ok', f.dataset.success || TXT.ok);
      m.focus({ preventScroll: true });
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email }); } catch (err) { /* ignore */ }
      try { document.dispatchEvent(new CustomEvent('nh:newsletter:subscribed', { detail: { source: sourceOf(f) } })); } catch (err) { /* ignore */ }
      return;
    }
    if (res && res.status === 400) {
      show(f, 'err', TXT.bad);
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    // Klaviyo unreachable, rate-limited or erroring: fall back to the Shopify customer form.
    nativeSubmit(f);
  }, true);
})();
